const state = {
    track: {},
    playing: false,
    initialized: false
};

const getters = {};

const actions = {
    setTrack: function(context, track) {
        context.commit("setTrack", track);
    },
    setStatus: function(context, status) {
        context.commit("setPlaying", status);
    }
};

const mutations = {
    setTrack: function(state, track) {
        state.track = track;
        if (state.playing == true) {
            ga("send", "event", "Audio", "play", track.name);
        }
    },
    setPlaying: function(state, status) {
        state.playing = status;
        ga(
            "send",
            "event",
            "Audio",
            status ? "play" : "pause",
            state.track.name
        );
        state.initialized = true;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};